export const MainPath = '/';
export const PRODUCT_MANAGER_PATH = '/product';
export const  MANAGE_GARAGE = '/manage-garage';
export const  MANAGE_GARAGE_ADD = '/manage-garage/add';
export const LOGIN_PATH = '/auth/login';
export const LABEL_MANAGER_PATH = '/productEntity';
export const ROLL_MANAGER_PATH = '/roll';
